import { render, staticRenderFns } from "./UserShareAccess.vue?vue&type=template&id=93f63266&"
import script from "./UserShareAccess.vue?vue&type=script&lang=ts&"
export * from "./UserShareAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports